export const MANAGEMENT_PAYMENT_TYPE = [
  {
    label: "청구해지",
    value: "cancel"
  },
  {
    label: "정기청구",
    value: "periodic"
  },
  {
    label: "개별청구",
    value: "single"
  },
];

export const MANAGEMENT_PAYMENT_STATUS = [
  {
    label: "납부대기",
    value: "wait"
  },
  {
    label: "미납",
    value: "unPaid"
  },
  {
    label: "납부",
    value: "complate"
  },
];


export const PAYMENT_TYPE = [
  { label: "카드", value: "card" },
  { label: "계좌이체", value: "cash" }
];

export const MANAGEMENT_TYPE = [
  { value: "bookKeeping", label: "기장" },
  { value: "accountingSupport", label: "경리지원" },
  { value: "reportingAgent", label: "신고대리" },
  { value: "etc", label: "기타" },
];

export const PAYPERIODIC_CYCLE_UNIT = [
  { label: "매월", value: "month" },
  { label: "매주", value: "week" },
  { label: "매일", value: "date" },
  { label: "매년", value: "year" },
];

export const BILLING_STATUS = [
  { label: "청구진행", value: "progress" },
  { label: "청구해지", value: "cancel" },
];

export const TAXPAYER_EXPIRED_TYPE = [
  { label: "폐업", value: "close" },
  { label: "이관", value: "escalation" },
  { label: "법인전환", value: "changeCorp" },
  { label: "신고대리 전환", value: "changeReportingAgent" },
  { label: "기타", value: "etc" },
];